<template>
  <div>
    <v-tabs
      fixed-tabs
      color="dover-blue"
      slider-color="yellow"
      dark
      icons-and-text>
      <v-tab
        :key="1"
        ripple>
        {{ $t('Site info') }}
        <v-icon>mdi-information-outline</v-icon>
      </v-tab>
      <v-tab-item
        :key="1">
        <MaglinkSystemSiteInfo
          :title="`${ $t('Site info') }`"
          :features="features"
          @settingsSaved="onSettingsSaved" />
      </v-tab-item>
      <v-tab
        :key="2"
        ripple>
        {{ $t('System') }}
        <v-icon>mdi-laptop</v-icon>
      </v-tab>
      <v-tab-item
        :key="2">
        <MaglinkSystemSettings
          :title="`${ $t('System') }`"
          @settingsSaved="onSettingsSaved" />
      </v-tab-item>
      <v-tab
        :key="3"
        ripple>
        {{ $t('Protocols') }}
        <v-icon>mdi-lan-pending</v-icon>
      </v-tab>
      <v-tab-item
        :key="3">
        <MaglinkSystemProtocols
          :title="`${ $t('Protocols') }`"
          @settingsSaved="onSettingsSaved" />
      </v-tab-item>
      <v-tab
        :key="4"
        ripple>
        {{ $t('Tank groups') }}
        <v-icon>mdi-group</v-icon>
      </v-tab>
      <v-tab-item
        :key="4">
        <MaglinkSystemTankGroup
          :title="`${ $t('Tank groups') }`"
          @settingsSaved="onSettingsSaved" />
      </v-tab-item>
      <v-tab
        :key="5"
        ripple>
        {{ $t('Shifts') }}
        <v-icon>mdi-swap-horizontal</v-icon>
      </v-tab>
      <v-tab-item
        :key="5">
        <MaglinkSystemShifts
          :title="`${ $t('Shifts') }`"
          @settingsSaved="onSettingsSaved" />
      </v-tab-item>
      <v-tab
        :key="6"
        ripple>
        {{ $t('Fairbanks') }}
        <v-icon>mdi-cube-send</v-icon>
      </v-tab>
      <v-tab-item
        :key="6">
        <MaglinkSystemFairbanks
          :title="`${ $t('Fairbanks') }`"
          @settingsSaved="onSettingsSaved" />
      </v-tab-item>
      <v-tab
        :key="7"
        ripple>
        {{ $t('Smtp').toUpperCase() }}
        <v-icon>mdi-email</v-icon>
      </v-tab>
      <v-tab-item
        :key="7">
        <MaglinkSystemSmtp
          :title="`${ $t('Smtp').toUpperCase() }`"
          @settingsSaved="onSettingsSaved" />
      </v-tab-item>
      <v-tab
        :key="8"
        ripple>
        {{ $t('Site mapping') }}
        <v-icon>mdi-sitemap</v-icon>
      </v-tab>
      <v-tab-item
        :key="8">
        <MaglinkSystemSiteMapping
          :title="`${ $t('Site mapping') }`"
          @settingsSaved="onSettingsSaved" />
      </v-tab-item>
      <v-tab
        :key="9"
        ripple>
        {{ $t('IFSF') }}
        <v-icon>mdi-developer-board</v-icon>
      </v-tab>
      <v-tab-item
        :key="9">
        <MaglinkSystemIfsf
          :title="`${ $t('IFSF') }`"
          @settingsSaved="onSettingsSaved" />
      </v-tab-item>
      <!--
      <v-tab
        :key="9"
        ripple>
        {{ $t('Dipswitches') }}
        <v-icon>mdi-dip-switch</v-icon>
      </v-tab>
      <v-tab-item
        :key="9">
        <MaglinkSystemDipswitch />
      </v-tab-item>
      -->
    </v-tabs>
    <v-flex
      xs12
      md12
      text-xs-center>
      <v-btn
        :disabled="!applyNeeded"
        medium
        class="mx-0 font-weight-bold"
        color="dover-blue"
        @click="applySettings">
        {{ $t('Apply settings to console') }}
      </v-btn>
    </v-flex>
  </div>
</template>

<script>
export default {
  data: () => ({
    applyNeeded: false,
    features: undefined
  }),
  mounted () {
    // CHECK PERMISSION
    // *******************************************************************
    this.Maglink.CheckPermission()
    // *******************************************************************

    this.Maglink.IsApplyNeeded()
      .then(response => (this.applyNeeded = response.data))
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetSettings('Features')
      .then(response => (this.features = { ...this.features, ...response.data }))
      .catch(error => (this.snack('error', error.message)))
  },
  methods: {
    remove (item) {
      this.notificationContacts.splice(this.notificationContacts.indexOf(item), 1)
      this.notificationContacts = [...this.notificationContacts]
    },
    onSettingsSaved () {
      this.applyNeeded = true
    },
    applySettings () {
      this.Maglink.ApplySettings()
        .then(response => {
          this.applyNeeded = false
          this.snack('success', response.data['done'])
        })
        .catch(error => (this.snack('error', error.message)))
    },
    snack (color, message) {
      message = this.$t('System') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
